import { createContext } from 'react';

const ComputedHeightsContext = createContext(new Map());

export default ComputedHeightsContext;
